import { Phone, Zap } from "lucide-react";
import { useEffect, useState } from "react";
import { SITE } from "@/lib/siteConfig";

export default function TopAlertBar() {
  const [time, setTime] = useState("");

  useEffect(() => {
    const update = () => {
      const d = new Date();
      setTime(
        d.toLocaleTimeString("fr-FR", {
          hour: "2-digit",
          minute: "2-digit",
        })
      );
    };
    update();
    const id = setInterval(update, 30000);
    return () => clearInterval(id);
  }, []);

  return (
    <div
      data-testid="top-alert-bar"
      className="bg-[#0A0A0A] text-white relative overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between gap-3 py-2.5 text-xs sm:text-sm">
          <div className="flex items-center gap-2.5 min-w-0">
            <span className="relative flex h-2.5 w-2.5 flex-shrink-0">
              <span className="absolute inline-flex h-full w-full rounded-full bg-red-500 opacity-75 animate-ping" />
              <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-red-500" />
            </span>
            <span className="font-bold uppercase tracking-wider truncate">
              <span className="hidden sm:inline">Besoin d'un dépannage actuellement ?</span>
              <span className="sm:hidden">Dépannage urgent ?</span>
            </span>
            <span className="hidden md:inline-flex items-center gap-1 bg-white/10 border border-white/15 px-2 py-0.5 text-[10px] tracking-[0.2em] uppercase font-bold">
              <Zap className="w-3 h-3 text-yellow-400" strokeWidth={3} />
              Serrurier en ligne
            </span>
            <span className="hidden lg:inline text-white/60">· Il est {time}</span>
          </div>
          <a
            href={SITE.phoneHref}
            data-testid="top-alert-call"
            className="inline-flex items-center gap-2 bg-red-600 hover:bg-red-500 text-white px-3 sm:px-4 py-1.5 sm:py-2 font-display font-black text-xs sm:text-sm tracking-tight transition-all hover:-translate-y-0.5 flex-shrink-0"
          >
            <Phone className="w-3.5 h-3.5" strokeWidth={3} />
            <span className="hidden sm:inline">Appeler maintenant</span>
            <span className="sm:hidden">Appeler</span>
          </a>
        </div>
      </div>
    </div>
  );
}
